import { useCurrentStateAndParams } from "@uirouter/react";

import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { WebsitePageQueryBar } from "app/components/compare/WebsiteQueryBar/WebsitePageQueryBar";
import { useAutoScrollTop } from "app/custom-hooks/useAutoScrollTop";
import { translate } from "app/filters/i18nFilter";
import companyAnalysisTrackingService from "app/pages/sales-intelligence/modules/company-analysis/services/tracking/companyAnalysisTrackingService";
import PageTitle from "app/pages/sales-intelligence/pages/company-analysis/components/shared/PageTitle/PageTitle";
import { Tabs } from "app/pages/sales-intelligence/pages/company-analysis/components/shared/Tabs/Tabs";
import WebsitePageHeader from "app/pages/sales-intelligence/pages/company-analysis/containers/header/PageHeader/WebsitePageHeader";
import { WEBSITE_ANALYSIS_TABS } from "app/pages/sales-intelligence/pages/company-analysis/routing/website-tabs-config";
import WebsiteQueryBar from "app/components/compare/WebsiteQueryBar/WebsiteQueryBar";
import { PageNotificationBarContainer } from "app/components/React/NotificationBarContainer/PageNotificationBarContainer";
import { InfoBanner } from "app/components/React/PlaResearch/InfoBanner";
import { SwDemoBanner } from "app/components/sw-demo-banner/SwDemoBanner";
import { WebsiteAnalysisProvider } from "app/pages/website-analysis/frame/WebsiteAnalysisContext";
import { WebsiteAnalysisPageFrame } from "app/pages/website-analysis/frame/WebsiteAnalysisPageFrame";
import { DEFAULT_PAGE_LAYOUT_CLASS_NAME } from "app/UtilitiesAndConstants/Constants/css";
import { InfoBannerContainer } from "app/UtilitiesAndConstants/UtilitiesComponents/InfoBannerContainer";

import { StyledWebsiteQueryBarContainer } from "./styles";

export const SalesWebsiteAnalysisRedesignModuleFrame = () => {
    const {
        state,
        params: { key: domain },
    } = useCurrentStateAndParams();

    const autoScrollRef = useAutoScrollTop();

    const pageLayoutClassName = state.pageLayoutClassName ?? DEFAULT_PAGE_LAYOUT_CLASS_NAME;
    const QueryBar = state.supportsPageFilter ? WebsitePageQueryBar : WebsiteQueryBar;

    const handleTabClick = (tabName: string) => {
        companyAnalysisTrackingService.trackWebsiteTabClick(tabName, domain);
    };

    return (
        <WebsiteAnalysisProvider>
            <SwDemoBanner type="basic" />
            <InfoBanner
                displayInTab="plaResearch"
                userDataBannerKey="userDataBannerKeyWAPla"
                text="keyword.analysis.plaResearch.page.toolTip.text"
                title="keyword.analysis.plaResearch.page.toolTip.title"
            />
            <InfoBannerContainer
                displayInPage={["organicsearch_websites_v2_traffic_keywords"]}
                text="analysis.search.keywords.info.banner.text"
                title="analysis.search.keywords.info.banner.title"
                displayInDuration={["28d"]}
                displayInWebSource={["MobileWeb"]}
            />
            <PageNotificationBarContainer />
            <WebsitePageHeader />
            <Box
                padding="0"
                className="sw-layout-scrollable-element sw-layout-research"
                ref={autoScrollRef}
            >
                <PageTitle text={translate("si.company-analysis.website.title")} />
                <StyledWebsiteQueryBarContainer className="hidden-print">
                    <Flex
                        alignItems="center"
                        minHeight="37px"
                        margin="0 0 12px -16px"
                    >
                        <QueryBar
                            hideOverlay
                            disableWebsiteTooltip
                            compareButtonType="outlined"
                            handleColor={colorsPalettes.bluegrey[100]}
                            renderFavoriteButton={() => null}
                        />
                    </Flex>
                </StyledWebsiteQueryBarContainer>

                <Tabs
                    config={WEBSITE_ANALYSIS_TABS}
                    onTabClick={handleTabClick}
                    onSubTabClick={handleTabClick}
                />
                <Box margin="0 0 24px" />
                <div className={`sw-page-websiteAnalysis ${pageLayoutClassName}`}>
                    <section data-automation="page-frame-container">
                        <WebsiteAnalysisPageFrame />
                    </section>
                </div>
            </Box>
        </WebsiteAnalysisProvider>
    );
};
